const state = {
  user: null,
  token: null,
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setToken(state, token) {
    state.token = token;
  },
};

const actions = {
  login({ commit }, { user, token }) {
    commit('setUser', user);
    commit('setToken', token);
  },

  logout({ commit }) {
    commit('setUser', null);
    commit('setToken', null);
  },
};

const getters = {
  user: (state) => state.user,
  token: (state) => state.token,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
